<template>
  <div v-if="show" class="right sm">
    <small
      >{{ capitalize($route.params.brand) }} local time:
      <strong>{{ localTime }}</strong> ({{
        $timezones[this.$route.params.brand]
      }})</small
    >
  </div>
</template>
<script>
export default {
  data() {
    return {
      localTime: null,
      show: true,
    }
  },
  methods: {
    updateTime: function () {
      var localTz = this.$timezones[this.$route.params.brand]
      this.$moment.tz.setDefault(localTz)
      console.log(localTz)
      this.show = typeof localTz !== 'undefined'
      this.localTime = this.$moment().format('HH:mm')
    },
    capitalize: function (s) {
      return s.charAt(0).toUpperCase() + s.slice(1)
    },
  },
  created() {
    this.updateTime()
    var self = this
    this.localTimeUpdater = setInterval(function () {
      self.updateTime()
    }, 30000)
  },
  beforeDestroy() {
    clearInterval(this.localTimeUpdater)
  },
  watch: {
    $route() {
      this.updateTime()
    },
  },
}
</script>
